import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { excludedFields } from '../../../common/FieldTypes';
class UploadJonPreview extends Component {
  static propTypes = {
    csvData: PropTypes.array.isRequired,
    csvHeader: PropTypes.array.isRequired,
  };

  render() {
    const { csvData, csvHeader } = this.props;
    let filterHeader = csvHeader.filter((el) => !excludedFields.includes(el));
    const tableRows = csvData.map((rowData) => {
      const cells = filterHeader.map((headerKey) => {
        return rowData[headerKey];
      });
      return cells;
    });
    return (
      <div className="row">
        <div className="col-md-12 text-center">
          <h2>Imported JSON Content</h2>
        </div>
        <div className="col-md-12 table-responsive csv-preview-table w-100vh show_scrollbar">
          <table className="table table-bordered table-hover table-sm table-word-break">
            <thead>
              <tr>
                {Object.keys(filterHeader).map((key, index) => (
                  <th key={key}>{filterHeader[index]}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableRows.map((rowData, index) => (
                <tr key={index}>
                  {rowData.map((cellData, cellIndex) => (
                    <td key={cellIndex}>{cellData}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default UploadJonPreview;
